import { isStringAValidNumber } from "../../components/TwoFactorAuthModal";
import { isObject } from "../../form-v2/utils";

export function checkCountryFromSSN(ssn) {
    if (!ssn) return;
    if (ssn?.length === 10) {
        let check = true;
        let currentYear = new Date().getFullYear();
        let dd = ssn.substr(0, 2);
        let mm = ssn.substr(2, 2);
        let yy = ssn.substr(4, 2);
        let nnnn = ssn.substr(6, 4);
        let yyyy = (Number(yy) + 2000) < currentYear ? `${Number(yy) + 2000}` : Number(yy) + 1900;

        dd = Number(dd);
        mm = Number(mm);
        if (dd <= 0 || dd > 31) {
            check = false;
        }
        if (mm <= 0 || mm > 12) {
            check = false;
        }
        if (yyyy < 1850 || yyyy > currentYear) {
            check = false;
        }
        if (check) {
            return 'denmark';
        }
    }
    if (ssn?.length === 12) {
        let check = true;
        let currentYear = new Date().getFullYear();
        let yyyy = ssn.substr(0, 4);
        let mm = ssn.substr(4, 2);
        let dd = ssn.substr(6, 2);
        let nnnn = ssn.substr(8, 4);

        yyyy = Number(yyyy);
        dd = Number(dd);
        mm = Number(mm);
        if (dd <= 0 || dd > 31) {
            check = false;
        }
        if (mm <= 0 || mm > 12) {
            check = false;
        }
        if (yyyy < 1850 || yyyy > currentYear) {
            check = false;
        }
        if (check) {
            return 'sweden';
        }
    }
    return null;
}

export function getAgeFromDobOrSSN(dob, ssn) {
    try {
        if (dob && isObject(dob) && dob.date && typeof dob.date === 'string') {
            const date = new Date(dob.date);
            if (isNaN(date.getTime())) return null;

            const currentDate = new Date();
            const birthDate = new Date(date);
            birthDate.setHours(0, 0, 0, 0);

            const currentYear = currentDate.getFullYear();
            const currentMonth = currentDate.getMonth();
            const currentDay = currentDate.getDate();

            const birthYear = birthDate.getFullYear();
            const birthMonth = birthDate.getMonth();
            const birthDay = birthDate.getDate();

            let age = currentYear - birthYear;
            if (birthMonth > currentMonth || (birthMonth === currentMonth && birthDay > currentDay)) {
                age--;
            }

            return age;
        }
    } catch (err) { }

    try {
        if (ssn && typeof ssn === 'string' && ssn.length > 8) {
            const age = calculateAgeFromSSN(ssn);
            return age;
        }
    } catch (err) { }

    return null;
}

export function calculateAgeFromSSN(ssn, country) {
    if (!country) {
        if (typeof window !== 'undefined' && localStorage && localStorage?.getItem?.('country')) country = localStorage?.getItem?.('country');
        else country = 'sweden';
    };

    if (!ssn || !isStringAValidNumber(ssn)) return null;

    let day;
    let month;
    let year;

    if (country === 'denmark' && ssn.length === 12) {
        let check = true;
        let currentYear = new Date().getFullYear();
        let yyyy = ssn.substr(0, 4);
        let mm = ssn.substr(4, 2);
        let dd = ssn.substr(6, 2);
        let nnnn = ssn.substr(8, 4);

        yyyy = Number(yyyy);
        dd = Number(dd);
        mm = Number(mm);
        if (dd <= 0 || dd > 31) {
            check = false;
        }
        if (mm <= 0 || mm > 12) {
            check = false;
        }
        if (yyyy < 1850 || yyyy > currentYear) {
            check = false;
        }
        if (check) {
            country = 'sweden';
        }
    } else if (country === 'sweden' && ssn.length === 10) {
        let check = true;
        let currentYear = new Date().getFullYear();
        let dd = ssn.substr(0, 2);
        let mm = ssn.substr(2, 2);
        let yy = ssn.substr(4, 2);
        let nnnn = ssn.substr(6, 4);
        let yyyy = (Number(yy) + 2000) < currentYear ? `${Number(yy) + 2000}` : Number(yy) + 1900;

        dd = Number(dd);
        mm = Number(mm);
        if (dd <= 0 || dd > 31) {
            check = false;
        }
        if (mm <= 0 || mm > 12) {
            check = false;
        }
        if (yyyy < 1850 || yyyy > currentYear) {
            check = false;
        }
        if (check) {
            country = 'denmark';
        }
    }

    if (country === 'denmark') {
        if (ssn.length < 6) return null;
        day = Number(`${ssn[0]}${ssn[1]}`);
        month = Number(`${ssn[2]}${ssn[3]}`);
        const yearLastDigits = Number(`${ssn[4]}${ssn[5]}`);
        const nowYear = new Date().getFullYear();
        const nowYearLastDigits = `${String(nowYear)[2]}${String(nowYear)[3]}`;
        if (yearLastDigits === 0) year = 2000;
        else {
            if (yearLastDigits > +nowYearLastDigits) year = Number(`19${yearLastDigits < 10 ? '0' + yearLastDigits : yearLastDigits}`);
            else year = Number(`20${yearLastDigits < 10 ? '0' + yearLastDigits : yearLastDigits}`);
        }
    } else {
        if (ssn.length < 8) return null;
        year = parseInt(`${ssn[0]}${ssn[1]}${ssn[2]}${ssn[3]}`);
        month = parseInt(`${ssn[4]}${ssn[5]}`);
        day = parseInt(`${ssn[6]}${ssn[7]}`);
    }

    if (day && month && year) {
        // let date = new Date(year, month - 1, day);
        // let years = (new Date().getTime() / 1000 - date.getTime() / 1000) / 31556926;
        // return years;
        const currentDate = new Date();
        const birthDate = new Date(year, month - 1, day);
        birthDate.setHours(0, 0, 0, 0);

        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth();
        const currentDay = currentDate.getDate();

        const birthYear = birthDate.getFullYear();
        const birthMonth = birthDate.getMonth();
        const birthDay = birthDate.getDate();

        let age = currentYear - birthYear;

        if (birthMonth > currentMonth || (birthMonth === currentMonth && birthDay > currentDay)) {
            age--;
        }

        return age;
    };

    return null;
}